import gql from "graphql-tag";

import UserSettingsV2Fields from "lib/graphql/fragments/UserSettingsV2Fields";

import UserSettings from "../fragments/UserSettings";

export default gql`
  query Selfie {
    selfie {
      _id
      firstName
      lastName
      fullName
      email
      country
      isConnectedWithGoogle
      hasPasswordSet
      hasStripeAccount
      isPremium
      isTrialing
      isBlack
      isSiteAdmin
      isTrialing
      viewerCanPurchaseBlack
      viewerCanStartPremiumTrial
      viewerCanExportFinancialsData
      viewerCanRefer
      referralShareUrl
      pictureUrl
      signedUpAt
      intercom {
        appId
        verificationHash
        customAttributes
      }
      blackSubscriptionPeriod {
        startDate
        endDate
        isSeptember23LaunchSale
        isRenewable
        renewUntil
      }
      ...UserSettings
      settingsV2 {
        ...UserSettingsV2Fields
      }
      subscription {
        id
        status
        latestInvoice {
          id
          status
          nextPaymentAttempt
        }
      }
    }
  }

  ${UserSettings}
  ${UserSettingsV2Fields}
`;
